import z from "zod";
export var LocaleEnum;
(function (LocaleEnum) {
    LocaleEnum["EN"] = "en";
    LocaleEnum["CS"] = "cs";
})(LocaleEnum || (LocaleEnum = {}));
export const localeSchema = z.enum(LocaleEnum);
export const LOCALES = [LocaleEnum.EN, LocaleEnum.CS];
export const localeNativeName = {
    [LocaleEnum.EN]: "English",
    [LocaleEnum.CS]: "Čeština",
};
export const localeEnglishName = {
    [LocaleEnum.EN]: "English",
    [LocaleEnum.CS]: "Czech",
};
//# sourceMappingURL=locale.schema.js.map